import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentFieldsVisibilityAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentFieldsVisiblity`,
    method: 'get',
  });
};

export type ShipmentFieldsVisibilityResponse = {
  customerKey: number;
  columnName: string;
  moduleName: string; // 'Shipment'
  isVisible: 0 | 1;
}[];

export const fetchShipmentFieldsVisibility = async (): Promise<ShipmentFieldsVisibilityResponse> => {
  const response: AxiosResponse<ShipmentFieldsVisibilityResponse> = await getShipmentFieldsVisibilityAPI();
  return response.data;
};
